export default __webpack_public_path__ + "f15c3d0326e00892a18f9f66a857b393.png";